import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler, showSuccess } from 'utils';

import discoverPlaceApi from 'api/discoverPlace';
import * as ActionTypes from './actionTypes';
import {
  actionCreateDiscoverPlaceFailed,
  actionCreateDiscoverPlaceSuccess,
  actionDeleteDiscoverPlaceFailed,
  actionDeleteDiscoverPlaceSuccess,
  actionGetDiscoverPlaceDetailsFailed,
  actionGetDiscoverPlaceDetailsSuccess,
  actionGetDiscoverPlaceListFailed,
  actionGetDiscoverPlaceListSuccess,
  actionUpdateDiscoverPlaceFailed,
  actionUpdateDiscoverPlaceSuccess,
} from './actions';

function* createDiscoverPlace({ payload }) {
  try {
    const response = yield discoverPlaceApi.createDiscoverPlace(
      payload.payload,
    );
    const result = response?.payload ?? response;
    payload.callback();
    yield put(actionCreateDiscoverPlaceSuccess(result));
    showSuccess('Tạo địa điểm khám phá thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionCreateDiscoverPlaceFailed(error));
  }
}

function* getDiscoverPlaceList({ payload }) {
  try {
    const response = yield discoverPlaceApi.getDiscoverPlaceList(payload);
    const result = response?.payload ?? response;
    yield put(actionGetDiscoverPlaceListSuccess(result));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoverPlaceListFailed(error));
  }
}

function* deleteDiscoverPlace({ payload }) {
  try {
    yield discoverPlaceApi.deleteDiscoverPlace(payload.id);
    payload.callback();
    yield put(actionDeleteDiscoverPlaceSuccess(payload.id));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionDeleteDiscoverPlaceFailed(error));
  }
}

function* getDiscoverPlaceDetails({ payload }) {
  try {
    const response = yield discoverPlaceApi.getDiscoverPlaceDetails(payload);
    yield put(actionGetDiscoverPlaceDetailsSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoverPlaceDetailsFailed(error));
  }
}

function* updateDiscoverPlace({ payload }) {
  try {
    const response = yield discoverPlaceApi
      .updateDiscoverPlace(payload.id, payload.payload);
    payload.callback();
    yield put(actionUpdateDiscoverPlaceSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionUpdateDiscoverPlaceFailed(error));
  }
}

export default function* discoverPlace() {
  yield takeLeading(
    ActionTypes.CREATE_DISCOVER_PLACE,
    createDiscoverPlace,
  );

  yield takeLeading(
    ActionTypes.GET_DISCOVER_PLACE_LIST,
    getDiscoverPlaceList,
  );

  yield takeLeading(
    ActionTypes.DELETE_DISCOVER_PLACE,
    deleteDiscoverPlace,
  );

  yield takeLeading(
    ActionTypes.GET_DISCOVER_PLACE_DETAILS,
    getDiscoverPlaceDetails,
  );

  yield takeLeading(
    ActionTypes.UPDATE_DISCOVER_PLACE,
    updateDiscoverPlace,
  );
}
